import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled, { css } from "styled-components";
import { listStylesEnhancer } from "../../shared/listStylesEnhancer";
import List from "../../shared/List/List";
export var UlStyled = styled.ul.withConfig({
  displayName: "UnorderedList__UlStyled",
  componentId: "sc-1w7248o-0"
})(function (_ref) {
  var theme = _ref.theme,
      _ref$listStyleType = _ref.listStyleType,
      listStyleType = _ref$listStyleType === void 0 ? theme.componentsTokens.list.defaultUlMarker : _ref$listStyleType;
  var markerStyles = theme.componentsTokens.list.ulMarkers[listStyleType];
  return css(["& > li{&:before{content:", ";margin-right:", ";}}", ";"], markerStyles.style, markerStyles.gap, listStylesEnhancer);
});

var UnorderedList = function UnorderedList(props) {
  return /*#__PURE__*/React.createElement(List, _extends({
    Component: UlStyled
  }, props));
};

export default UnorderedList;